module.exports = __webpack_public_path__ + "static/media/IMG_1724.b55d03b2.JPG";